module.exports = __webpack_public_path__ + "static/img/diy-lan.2b63c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-lan.png
// module id = nppn
// module chunks = 0